import { Box, Typography } from "@mui/material";
import { CostScoreDisplay } from "./CostScoreDisplay";
import { CostScore } from "@labs/shared/types/Solution.ts";

type InvestmentType = {
  costScore: CostScore;
};

export const InvestmentLarge = ({ costScore }: InvestmentType) => (
  <Box component="dl">
    <Typography variant={"body2"} component="dt">
      Investment
    </Typography>
    <Typography variant={"h5"} component="dd">
      <CostScoreDisplay costScore={costScore} />
    </Typography>
  </Box>
);
